export default {"src":"/_next/static/media/blue-arrow.5c9e9809.svg","height":13,"width":24};